import React, { Component } from "react";
import PropTypes from "prop-types";
import styled, { css } from "styled-components";
import moment from "moment";
import Icon from "module-common/Icon";
import Avatar from "module-common/Avatar";
import LabelList from "module-common/label-list/LabelList";
import { Button } from "antd";

export default class Row extends Component {
  
  render() {
    const {
      id,
      index,
      firstName,
      lastName,
      phoneNumber,
      tagList,
      onEdit,
      onDelete
    } = this.props;

    return (
      <Wrapper>
        <Index>{index}.</Index>
        <Name>
            {firstName}
        </Name>
        <Name>
            {lastName}
        </Name>
        <Contact>{phoneNumber}</Contact>
        <Label>{tagList.map(item => item.displayName).join(", ")}</Label>
        <Index>
          <Button onClick={() => onEdit(this.props)}>Edit</Button>
          <Button type='danger' onClick={() => onDelete(this.props)}>Delete</Button>
        </Index>
      </Wrapper>
    );
  }
}

const Wrapper = styled.div`
  width: auto;
  height: auto;
  display: flex;
  flex: none;
  border-bottom: 1px solid ${props => props.theme.panelBorder};
  align-items: center;
  padding: 10px;
  &:hover {
    background: #ececec;
    font-weight: 600;
    cursor: pointer;
  }
`;

const Index = styled.div`
  margin-left: 10px;
  flex: 3;
`;

const Name = styled.div`
  flex: 3;
  text-align: left;
`;

const Contact = styled.div`
  flex: 3;
  text-align: left;
`;

const Label = styled.div`
  flex: 4;
  margin-right: 10px;
`;



// WEBPACK FOOTER //
// ./src/module-bulk-sms/contact/member/Row.js